import React, { useEffect, useState } from "react";
import sanityClient from "../client";
import { Link } from "react-router-dom";
import { useMediaQuery } from "@uidotdev/usehooks";
import NavBar from "./NavBar";
import NavBarMobile from "./NavBarMobile";
import Footer from "./Footer";
import Form from "./Form";
import BlockContent from "@sanity/block-content-to-react";

export default function Event() {
  const isSmallDevice = useMediaQuery("only screen and (max-width : 768px)");
  const allDevices = useMediaQuery("only screen and (min-width : 769px)");
  const [eventData, setEventData] = useState(null);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "event"] | order(_createdAt desc){
        _id,
        title,
        slug,
        description,
        autor,
        mainImage{
          asset->{
            _id,
            url
          }
        }
      }`,
      )
      .then((data) => setEventData(data))
      .catch(console.error);
  }, []);

  const latestEvent = eventData && eventData[0];
  const pastEvents = eventData && eventData.slice(1);

  return (
    <>
      {allDevices && <NavBar />}
      {isSmallDevice && <NavBarMobile />}

      <main className="bg-white-100 min-h-screen p-12">
        <section className="container max-w-screen-xl mx-auto">
          <h1 className="text-4xl flex pb-8">Pozivi za događaje</h1>

          {/* 🥇 FEATURED EVENT */}
          {latestEvent && (
            <section className="mb-16 flex flex-col items-center text-center">
              <img
                src={latestEvent.mainImage.asset.url}
                alt={latestEvent.title}
                className="w-full max-w-2xl mb-6"
              />

              <h2 className="text-3xl text-blue-600 mb-4">
                {latestEvent.title}
              </h2>

              <div className="text-gray-700 max-w-2xl">
                <BlockContent
                  blocks={latestEvent.description}
                  projectId="krjmu28b"
                  dataset="production"
                />
              </div>

              <p className="mt-4 text-gray-500">{latestEvent.autor}</p>

              {latestEvent.slug && (
                <Link
                  to={"/pozivi-za-dogadjaje/" + latestEvent.slug.current}
                  className="mt-6 text-blue-600 underline"
                >
                  Detaljnije
                </Link>
              )}
            </section>
          )}

          {/* 📚 PAST EVENTS */}
          {pastEvents && pastEvents.length > 0 && (
            <section>
              <h2 className="text-2xl mb-6">Prošli događaji</h2>

              <div className="grid md:grid-cols-3 gap-6">
                {pastEvents.map((event) => (
                  <article key={event._id} className="border p-4">
                    <img
                      src={event.mainImage.asset.url}
                      alt={event.title}
                      className="w-full mb-3"
                    />

                    <h3 className="text-lg text-blue-600">{event.title}</h3>

                    <p className="text-sm text-gray-600 mb-2">{event.autor}</p>

                    {event.slug && (
                      <Link
                        to={"/pozivi-za-dogadjaje/" + event.slug.current}
                        className="text-blue-600 underline"
                      >
                        Detaljnije
                      </Link>
                    )}
                  </article>
                ))}
              </div>
            </section>
          )}
        </section>
      </main>

      <Form />
      <Footer />
    </>
  );
}
